<div class="driver-view-container">
  <div class="trip-detail-popup-right">
    <img
      src="../../../assets/img/icons8-macos-close-60.png"
      class="close-icons"
      (click)="close()"
    />
  </div>
  <div class="driver-view">
    <div class="heading">
      <h3>Driver Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <div class="row m-0">
      <div class="col-xl-9 col-lg-8 col-md-6 col-sm-9">
        <div class="row mtb mr-0 ml-0">
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div class="head">Driver Name</div>
            <div class="dec">{{ driverData.username }}</div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div class="head">Mobile</div>
            <div class="dec">
              {{ driverData.mobile }}
              <img
                *ngIf="driverData.loginInfo[0].mobile_verified === 1"
                src="../../../assets/img/tick-verify.svg"
              />
              <div *ngIf="driverData.loginInfo[0].mobile_verified === 0">
                <img src="../../../assets/img/error.svg" /> <a>Send OTP</a>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <div class="head">Email</div>
            <div class="dec">{{ driverData.email }}</div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-xl-4 col-lg-12 col-md-6 col-sm-6">
            <div class="head">Driving License Number</div>
            <div class="dec">
              {{ driverData.driving_license_number }}
              <img
                *ngIf="driverData.is_dl_verified || driverData.dl_verified || driverData.documents?.is_dl_verified || driverData.documents?.dl_verified"
                src="../../../assets/img/tick-verify.svg"
                title="Sarathi Verified"
                style="width: 18px; margin-left: 8px; vertical-align: middle;"
              />
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-3 col-sm-6">
            <div class="head">Expiry Date</div>
            <div class="dec">
              {{ driverData.license_expiry_date | date : "dd-MM-yyyy" }}
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-3 col-sm-3">
            <div class="head">Assigned Truck Number</div>
            <div class="dec">{{ driverData.truckInfo[0]?.truck_number }}</div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-xl-4 col-lg-6 col-md-3 col-sm-3">
            <div class="head">Driver Known Languages</div>
            <div class="dec">{{ driverData.known_lang }}</div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-3 col-sm-3">
            <div class="head"></div>
            <div class="dec"></div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-3 col-sm-3">
            <div class="head">Emergency Number</div>
            <div class="dec">{{ driverData.emergency_contact }}</div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-xl-4 col-lg-6 col-md-3 col-sm-3">
            <div class="head">Status</div>
            <div class="dec">{{ driverData.driver_status | titlecase }}</div>
          </div>
          <div class="col-xl-4 col-lg-6 col-md-3 col-sm-3" *ngIf="reasons">
            <div class="head">Reasons</div>
            <div class="dec">{{ driverData.driver_remarks }}</div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-4 col-md-6 col-sm-3">
        <div class="right-side">
          <img
            src="{{
              driverData.profile_image
                ? driverData.profile_image
                : '../../../assets/img/driver.svg'
            }}"
            class="driverImg"
          />
          <div class="row mr-0 ml-0">
            <div class="col-sm-5 p-0">
              <div class="dec-head">Gender:</div>
            </div>
            <div class="col-sm-7 p-0">
              <div class="dec-right">
                {{ driverData.gender ? (driverData.gender | titlecase) : "" }}
              </div>
            </div>
            <div class="col-sm-4 p-0">
              <div class="dec-head">DOB:</div>
            </div>
            <div class="col-sm-8 p-0">
              <div class="dec-right">
                {{ driverData.dob | date : "dd-MM-yyyy" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mr-0 ml-0">
      <div class="row mb mr-0 ml-0">
        <div class="col-sm-6">
          <div class="head">Contact Details</div>
          <div class="dec">
            {{ driverData.contact_details?.address_line }},
            {{ driverData.contact_details?.area }},
            {{ driverData.contact_details?.city }},
            {{ driverData.contact_details?.state }},
            {{ driverData.contact_details?.pincode }}.
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="driverData.documents">
      <div class="heading">
        <h3>Documents</h3>
      </div>
      <mat-divider class="mb-3"></mat-divider>
      <div
        class="row mb mr-0 ml-0"
      >
        <div class="col-sm-4">
          <div class="head-b">Driving License</div>
        </div>
        <div class="col-sm-4">
          <div class="dec">
            {{
              driverData.documents.driving_license_expiry
                ? (driverData.documents.driving_license_expiry | date: "dd-MM-yyyy")
                : "NA"
            }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="dec-view">
            <a *ngIf="driverData.documents.driving_license" target="_blank" href="{{ driverData.documents.driving_license }}"
              >View</a
            >
          </div>
        </div>
      </div>
      <div
        class="row mb mr-0 ml-0"
      >
        <div class="col-sm-4">
          <div class="head-b">Insurance</div>
        </div>
        <div class="col-sm-4">
          <div class="dec">
            {{
              driverData.documents.insurance_expiry
                ? (driverData.documents.insurance_expiry | date: "dd-MM-yyyy")
                : "NA"
            }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="dec-view">
            <a *ngIf="driverData.documents.insurance" target="_blank" [href]="driverData.documents.insurance">
              View
            </a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="NotesData?.length > 0">
      <div class="heading">
        <h3>Driver Profile</h3>
      </div>
      <mat-divider></mat-divider>
      <div
        class="row mb mt-4 mr-0 ml-0"
        *ngFor="let item of NotesData; let i = index"
      >
        <div class="col-sm-3">
          <div class="note1">Note {{ i + 1 }}:</div>
          <div class="note2">{{ item.employee_name }}</div>
          <div class="note3">{{ item.date | date : "medium" }}</div>
        </div>
        <div class="col-sm-9">
          <div class="note2">{{ item.notes }}</div>
        </div>
      </div>
    </div>
    <div class="fixed-btn">
      <button (click)="editDriver()">Edit</button>
    </div>
  </div>
</div>
